import React, { Component } from "react";
import clsx from 'clsx';
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../../../assets/img/svg/save.svg';
import Cancel from '../../../../../../assets/img/svg/cancel.svg';
import Delete from '../../../../../../assets/img/svg/delete.svg'
import download from "../../../../../../assets/img/svg/DownloadIcon.svg"
import { Tabs, Tab, AppBar, Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import del from "../../../../../../assets/img/svg/Del.svg"
import { useNavigate } from "react-router-dom"
import Edit from '../../../../../../assets/img/svg/edit.svg';
import $ from "jquery"
import deactive from '../../../../../../assets/img/svg/deactive.svg';
import InnerImageZoom from "react-inner-image-zoom";
import withRouter from "../../../../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../../../../assets/jss/customStyle";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Ship from '../../../../../../assets/img/svg/Ship.svg';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import FilterIcon from '../../../../../../assets/img/svg/FilterIcon.svg'
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import axios from "axios";
import API from "../../../../../../_helpers/endpointService";
import { applyDataTable, destroyDataTable } from '../../../../../custom/dataTable';
import { getSD_ListView } from "../../../../../../actions/SectionAction";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({

    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
        padding: "5px 10px"
    },
}));

class TabSD extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            value: 0,
            sortindex:1,
            ProjectId: 0,
            SD_ListView: [],
            isView: false,
            hide: 0,
            UserRole: "",
            FileUrl: "",
            FileName: "",
            hide1: 0,
            index: 0,
            SD_Drawing: [],
            Delete: [],
            linkValue: 0,
            Delete1: [],
            searchDataSD: {
                ProjectId: 0,
                PageNumber: 1,
                PageSize: 10,
                SortBy: 'blockno',
                SortOrder: 'asc'
            },
        }
    }
    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
        })
        localStorage.setItem("SD", newValue)
        if (newValue == 1) {
            this.dataTable(this.state.searchDataSD, this.state.ProjectId);
        }
    };
    componentDidMount() {
        const { dispatch } = this.props;
        applyDataTable("staffTable")
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.searchDataSD.ProjectId = localStorage.getItem("DashId");
        this.state.linkValue = parseInt(localStorage.getItem("SD"));
        this.setState({})
        if (this.state.linkValue) {
            this.setState({
                value: this.state.linkValue
            })
        }
        else {
            localStorage.setItem("SD", 0)
            this.setState({
                value: 0
            })
        }
        this.dataTable(this.state.searchDataSD, this.state.ProjectId);
        this.Drawing(this.state.ProjectId)
        window.location.pathname == '/dismantlingplan/sectiondivision/edit' ? this.setState({ isView: false }) : this.setState({ isView: false })
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        if (!window.location.pathname.includes('dismantlingplan/sectiondivision')) {
            localStorage.removeItem("SD")
        }
        this.props.dispatch({ type: "SD", data: false })
        $("#SEC1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Dissecdiv1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Dissecdiv").addClass("d-none");
        $("#Dissecdiv").removeClass("d-block");
        $("#SDL").removeClass("active-color");
        $("#SDT").removeClass("fw-bolder");
    }

    dataTable = (data, id) => {

        let apiUrl = API.BLOCK_DIVISION + '?id=' + id + '&SortBy=' + data.SortBy + '&SortOrder=' + data.SortOrder +'&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;

        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    destroyDataTable("staffTable");
                    this.props.dispatch({ type: "SD_LISTVIEW", data: response.data });
                    applyDataTable("staffTable", "", [{ "orderable": false, "targets": [0], visible: this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? true : false }], "", "", "", "",[this.state.sortindex,data.SortOrder]) }
                else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

            });
    }
    Drawing = (id) => {
        let apiUrl = API.DRAWING_DIVISION + '/ProjectId?projectId=' + id

        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.dispatch({ type: "SD_DRAWING", data: response.data });
                    this.setState({
                        SD_Drawing: [],
                    })
                    response.data.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                    this.setState({
                        SD_Drawing: response.data,
                    })
                }
                else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

            });
    }
    DeleteSection = () => {
        let tempData = [];
        const { Delete } = this.state;
        window.$("#deletepopup").modal("hide");
        this.deletemultiSection(Delete)
        this.state.Delete = [];
        this.setState({});
        //this.dataTable(this.state.searchDataSD, this.state.ProjectId);
        $('input[type=checkbox]').prop('checked', false);
    }
    DeleteDrawing = () => {
        let tempData = [];
        const { Delete1 } = this.state;

        window.$("#deletepopup").modal("hide");
        this.deletemultiDrawing(Delete1)


        //this.Drawing(this.state.ProjectId)
        $('input[type=checkbox]').prop('checked', false);



    }
    deletemultiSection = (data) => {
        let ids = "";
        if (data && data.length > 0) {
            data.map((val, index) => {
                if (index == 0) {
                    ids += "ids=" + val;
                }
                else {
                    ids += "&ids=" + val;
                }
            })
        }

        let apiUrl = API.BLOCK_DIVISION + '/ids?' + ids;

        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.setState({
                        hide: [],
                    })
                    this.state.Delete = [];
                    this.state.searchDataSD = {
                        ProjectId: localStorage.getItem("DashId"),
                        PageNumber: 1,
                        PageSize: 10,
                        SortBy: 'blockno',
                        SortOrder: 'asc'
                    };
                    this.setState({});
                    this.dataTable(this.state.searchDataSD, this.state.ProjectId);
                    // this.dataTable(this.state.searchDataSD, this.state.ProjectId);

                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {

                }
            });
    };
    BackPage = () => {
        this.state.searchDataSD.PageNumber = this.state.searchDataSD.PageNumber - 1;
        this.setState({})
        this.dataTable(this.state.searchDataSD, this.state.ProjectId)
    }

    NextPage = () => {
        this.state.searchDataSD.PageNumber = this.state.searchDataSD.PageNumber + 1;
        this.setState({})
        this.dataTable(this.state.searchDataSD, this.state.ProjectId)
    }
    deletemultiDrawing = (data) => {
        let ids = "";
        if (data && data.length > 0) {
            data.map((val, index) => {
                if (index == 0) {
                    ids += "ids=" + val;
                }
                else {
                    ids += "&ids=" + val;
                }
            })
        }

        let apiUrl = API.BLOCK + 'DismantlingPlan/ids/SectionPlan?' + ids;

        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: true })

                if (response?.status === 200) {
                    this.setState({
                        hide1: [],
                    })
                    this.state.Delete1 = [];
                    this.setState({});
                    this.Drawing(this.state.ProjectId)

                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {

                }
            });
    };
    sidebar = () => {
        this.props.navigate("/sidebar");
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }

        this.state.SD_ListView = this.props.SD_ListView;
        //this.state.SD_Drawing = this.props.SD_Drawing;
        this.setState({})
    };
    resize1 = () => {
        $("#SEC1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Dissecdiv1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Dissecdiv").removeClass("d-none");
        $("#Dissecdiv").addClass("d-block");
        $("#SDL").addClass("active-color");
        $("#SDT").addClass("fw-bolder");
    }
    EditPage = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/dismantlingplan/sectiondivision/edit/" + this.state.value)
    };
    EditPageLink = (id) => {
        localStorage.setItem("SDEditId", id)
        this.props.navigate("/dismantlingplan/sectiondivision/edit/" + this.state.value)
    };
    EditPageDRAW = (id) => {
        localStorage.setItem("DrawEditId", id)
        this.props.navigate("/dismantlingplan/sectiondivision/edit/" + this.state.value)
    };
    AddNew = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        { this.state.value == 0 ? this.state.SD_Drawing.length >= 15 ? window.$("#Informationpopup").modal("show") : this.props.navigate("/dismantlingplan/sectiondivision/addnew/" + this.state.value) : this.props.navigate("/dismantlingplan/sectiondivision/addnew/" + this.state.value) }
    }
    handleCheckboxChange = (e, x) => {
        const { Delete } = this.state;
        if (Delete.length == 0) {
            Delete.push(x)
        }
        else {
            if (Delete.filter((i) => i == x).length == 1) {
                Delete.map((i, ind) => (
                    i == x ?
                        Delete.splice(ind, 1)
                        : ""
                ))
            } else {
                Delete.push(x)
            }
        }
        this.setState({})
        if (Delete.length == 1) {
            localStorage.setItem("SDEditId", Delete[0])
        }

        this.state.hide = Delete.length;
        this.setState({})

    };
    OpenPopupview = (url, name, ind) => {
        this.state.FileUrl = url;
        this.state.FileName = name;
        this.state.index = ind;
        this.setState({})
        window.$("#viewscreen").modal("show");
    }
    nextView = (ind) => {
        if (this.state.SD_Drawing.length === ind) {
            this.setState({
                index: 0
            })
        }
        else {
            this.setState({
                index: ind
            })
        }

    }
    preView = (ind) => {
        if (ind === -1) {
            this.setState({
                index: this.state.SD_Drawing.length - 1
            })
        }
        else {
            this.setState({
                index: ind
            })
        }

    }
    setIndex = (ind) => {
        this.setState({
            index: ind
        })
    }
    handleCheck = (e, x) => {
        const { Delete1 } = this.state;
        if (Delete1.length == 0) {
            Delete1.push(x)
        }
        else {
            if (Delete1.filter((i) => i == x).length == 1) {
                Delete1.map((i, ind) => (
                    i == x ?
                        Delete1.splice(ind, 1)
                        : ""
                ))
            } else {
                Delete1.push(x)
            }
        }
        this.setState({})
        if (Delete1.length == 1) {
            localStorage.setItem("DrawEditId", Delete1[0])
        }

        this.state.hide1 = Delete1.length;
        this.setState({})
    };
    Cancel = () => {
        window.$("#Informationpopup").modal("hide")
    }
    Render = () => {

    }
    handleSort = (data,ind) => {
        if (this.state.searchDataSD.SortBy === data) {
            this.state.searchDataSD.SortOrder = this.state.searchDataSD.SortOrder === "asc" ? "desc" : "asc";
        }
        else {
            this.state.searchDataSD.SortOrder = "asc";
        }
        this.state.searchDataSD.SortBy = data
        this.state.searchDataSD.PageNumber = 1;
        this.setState({
            sortindex:ind
        });
        this.dataTable(this.state.searchDataSD, this.state.ProjectId);

    }
    render() {
        let { classes, menuToggle } = this.props;

        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"SEC" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="SEC" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>Section Division</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className={this.state.isMobile ? "ml-auto scroll-hide border-top" : "ml-auto scroll-hide"} style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? <>
                        {this.state.isMobile ? <table className="dataTable " width="100%">
                            <tbody>
                                <tr>
                                    <td className="border-right text-center">
                                        <button className={`${classes.button}`} onClick={this.EditPage} disabled={this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? this.state.value == 1 ? this.state.hide == 1 ? false : true : this.state.hide1 == 1 ? false : true : true} style={{ minWidth: '70px' }}><img src={Edit} style={{ marginTop: '-4px', opacity: this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? this.state.value == 1 ? this.state.hide == 1 ? '' : '0.5' : this.state.hide1 == 1 ? '' : '0.5' : '0.5' }}></img>&nbsp;Edit</button>
                                    </td>
                                    <td className="border-right text-center">
                                        <button className={`${classes.button}`} style={{ minWidth: '70px' }} disabled={this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? this.state.value == 1 ? this.state.hide > 0 ? false : true : this.state.hide1 > 0 ? false : true : true} data-target="#deletepopup" data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? this.state.value == 1 ? this.state.hide > 0 ? '' : '0.5' : this.state.hide1 > 0 ? '' : '0.5' : '0.5' }}></img>&nbsp;Delete</button>
                                    </td>
                                    <td className="border-right text-center">
                                        <button className={`${classes.button} px-0`} onClick={this.AddNew} disabled={this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? false : true} style={{ minWidth: '70px', whiteSpace: 'nowrap' }}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? '' : '0.5' }}></i>Add New</button>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                            :
                            <>
                                <div className="row  border-bottom">
                                    <div className="col-xl-3  col-md-3 col-lg-3 col-sm-3   d-flex">
                                        <button className={`${classes.button} pl-3`} onClick={this.EditPage} disabled={this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? this.state.value == 1 ? this.state.hide == 1 ? false : true : this.state.hide1 == 1 ? false : true : true} style={{ minWidth: '70px' }}><img src={Edit} style={{ marginTop: '-4px', opacity: this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? this.state.value == 1 ? this.state.hide == 1 ? '' : '0.5' : this.state.hide1 == 1 ? '' : '0.5' : '0.5' }}></img>&nbsp;Edit</button>
                                        <button className={`${classes.button}`} style={{ minWidth: '70px' }} disabled={this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? this.state.value == 1 ? this.state.hide > 0 ? false : true : this.state.hide1 > 0 ? false : true : true} data-target="#deletepopup" data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? this.state.value == 1 ? this.state.hide > 0 ? '' : '0.5' : this.state.hide1 > 0 ? '' : '0.5' : '0.5' }}></img>&nbsp;Delete</button>

                                        <div className="col-xl-12 p-3 col-md-12 col-lg-12 col-sm-12  ml-2 border-left">
                                            <button className={classes.button} onClick={this.AddNew} disabled={this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? false : true} style={{ minWidth: '70px' }}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? '' : '0.5' }}></i>Add New</button>
                                        </div>
                                    </div>
                                </div>
                            </>

                        }
                    </> : <></>}
                    <div style={{ margin: this.state.isMobile ? "0" : "2px" }}>
                        {this.state.isMobile ? <></> : <h6 className="col-12 mt-3 ml-1">Section Division</h6>}
                        <div className="row">
                            <div >
                                <AppBar position="static" color="inherit" className={classes.root} style={{ margin: '0' }}>
                                    <Tabs
                                        value={this.state.value}
                                        onChange={this.handleChange}
                                        classes={{ indicator: classes.indicator }}
                                    >
                                        <Tab label="Drawing" className="f-size-12 px-1 ml-4" style={{ textTransform: "none", minWidth: '13px' }}{...a11yProps(0)} />
                                        <Tab label="Section Detail" style={{ textTransform: "none", minWidth: '10px' }}{...a11yProps(1)} />
                                    </Tabs>
                                </AppBar>
                                <TabPanel value={this.state.value} index={0}>
                                    <>
                                        <div className="row mt-n3">
                                            {this.state.SD_Drawing.length == 0 ? <>
                                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
                                                    <span className="spandoc-thead">Title :</span>
                                                </div>
                                                <div className="row" >
                                                    <div className="d-flex mt-2">
                                                        <span className="pr-2 mr-1 spandoc-thead">Drawing :</span>

                                                    </div>
                                                </div></> :
                                                <>
                                                    <div className="row m-auto px-0">
                                                        {this.state?.SD_Drawing?.map((i, ind) => (<>
                                                            <div className=" mt-2">
                                                                <div className="px-0 d-flex">
                                                                    {this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? <>
                                                                        <div>
                                                                            <input type="checkbox" className="mr-2 mt-1" style={{ height: '16px', width: '16px' }} onClick={(e) => this.handleCheck(e, i.Id)} />
                                                                        </div>
                                                                    </> : <></>}
                                                                    <label className="spandoc-thead overflow col-11 px-0">{this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? <> <a href="#" onClick={() => this.EditPageDRAW(i.Id)}>{i.Title}</a></> : <>{i.Title}</>}</label>
                                                                </div>
                                                                {i.Drawing == null ? <>
                                                                </> :
                                                                    <div className="text-row px-0 pt-2 pb-2 text-center">
                                                                        <img className="img-fluid px-2 " onClick={() => this.OpenPopupview(i.Drawing?.FileUrl, i.Drawing?.FileName, ind)}  src={i.Drawing?.FileUrl}></img>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </>))
                                                        }
                                                    </div>
                                                </>
                                            }
                                        </div>

                                    </>
                                </TabPanel>
                                <TabPanel value={this.state.value} index={1}>
                                    <>
                                        <div className="row mt-n2" >
                                            <div className="col-12 col-sm-12 px-3">
                                                <div className="table-responsive mb-5" style={{ width: "100%" }}>
                                                    <table id="staffTable" className="table table-hover">
                                                        <thead>
                                                            <tr className="">
                                                                <th className="border-left" width="3%"></th>
                                                                <th className="border-right border-left" style={{ minWidth: '200px' }} onClick={() => this.handleSort('blockno',1)}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Block Number</span></th>
                                                                <th className="border-right" style={{ minWidth: '200px' }} onClick={() => this.handleSort('sectionno',2)}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Section Number</span></th>
                                                                <th className="border-right" style={{ minWidth: '200px' }} onClick={() => this.handleSort('sectiontype',3)}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Section Type</span></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.props.SD_ListView?.Sectiontype && this.props.SD_ListView?.Sectiontype.map((i, v) => (
                                                                <tr>
                                                                    <td className="spandoc-td align-middle border-left border-right"><input type="checkbox" checked={this.state.Delete.filter(r=> r === i.Id).length == 1 ? true : false} style={{ height: '16px', width: '16px' }} onChange={(e) => this.handleCheckboxChange(e, i.Id)} /></td>
                                                                    <td className="spandoc-td border-left border-right"><span className="spandoc-td"> {this.state.UserRole === "Admin" || this.state.UserRole === "Supervisor" ? <a href="#" onClick={() => this.EditPageLink(i.Id)}>{i.BlockNo}</a> : <>{i.BlockNo}</>}</span></td>
                                                                    <td className="spandoc-td border-right"><span className="spandoc-td">{i.SectionNumber}</span></td>
                                                                    <td className="spandoc-td border-right"><span className="spandoc-td">{i.Sectiontype}</span></td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>

                                        </div>

                                        <div className="modal left fade pt-5 mt-3" id="custom-modal" tabIndex={-1} role="dialog" aria-hidden="true">
                                            <div className="modal-dialog modal-dialog-centered">
                                                <div className="modal-content border-radius">
                                                    <div className="modal-header">
                                                        <div className="row m-0">
                                                            <h6 className="modal-title" id="myCenterModalLabel">Advanced Filter</h6>
                                                            <div className="col-12">
                                                                <img src={FilterIcon} />&nbsp;<span>Reset to default</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="modal-body p-4">
                                                        <form id="myform">
                                                            <div className="form-group row">
                                                                <div className="col-5 m-auto">
                                                                    <label htmlFor="name">Block Division</label></div>
                                                                <div className="col-7">
                                                                    {/* <Autocomplete
                                    renderInput={(props) => {
                                        return (
                                            <input
                                                className="form-control border-radius"
                                                id="exampleFormControlInput1"
                                                {...props}
                                                style={{ width: 223 }}
                                            />
                                        );
                                    }}
                                /> */}
                                                                    <TextField
                                                                        variant="outlined"
                                                                        size="small"
                                                                        fullWidth

                                                                        InputProps={{
                                                                            className: `border-radius ${classes.inputfieldAlign}`
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group row">
                                                                <div className="col-5 m-auto">
                                                                    <label htmlFor="name">Section Division</label></div>
                                                                <div className="col-7">
                                                                    {/* <Autocomplete
                                    renderInput={(props) => {
                                        return (
                                            <input
                                                className="form-control border-radius"
                                                id="exampleFormControlInput1"
                                                {...props}
                                                style={{ width: 223 }}
                                            />
                                        );
                                    }}
                                /> */}
                                                                    <TextField
                                                                        variant="outlined"
                                                                        size="small"
                                                                        fullWidth

                                                                        InputProps={{
                                                                            className: `border-radius ${classes.inputfieldAlign}`
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row text-center mt-4">
                                                                <div className="col-2"></div>
                                                                <div className="col-5">
                                                                    <button type="button" className="btn input-group border-radius f-size-13 filter-btn" style={{ backgroundColor: "#00838F", color: "#FFFFFF" }}>Search</button>
                                                                </div>
                                                                <div className="col-5" data-dismiss="modal">
                                                                    <button type="button" className="btn btn-light input-group border-radius f-size-13 filter-btn">Reset</button>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div >

                                    </>
                                </TabPanel>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>

                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>

                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.state.value == 1 ? this.DeleteSection : this.DeleteDrawing}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div class="modal fade p-5 mt-5" id="Informationpopup" tabindex="-1" role="dialog" aria-labelledby="InformationpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>

                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">You can't add more than 15 drawings</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary text-center" : " btn btn-secondary py-2 px-4 text-center"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.Cancel()}><span className="" >Ok</span></button>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div class="modal fade p-5 mt-5" id="Informationpopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">You can't add more than 15 drawings</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" id="closemodal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.Cancel}><span className="" >Ok</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.state.value == 1 ?
                        <div className={`${classes.pagination}`}>
                            <div className={`${classes.paginationItem}`}>
                                {this.state.searchDataSD.PageNumber === 1 ? <></> :
                                    <ArrowBackIcon className={classes.arrow} onClick={() => this.BackPage()} />}
                                <span className="pl-2 pr-2">Page {this.state.searchDataSD.PageNumber}</span>
                                {(this.state.searchDataSD.PageNumber === this.props.SD_ListView?.pagination?.PageCount) || (this.props.SD_ListView?.pagination?.PageCount == 0) ? <></> :
                                    <ArrowForwardIcon className={classes.arrow} onClick={() => this.NextPage()} />}
                            </div>
                        </div>
                        : <></>
                }
                <div class="modal fade " id="viewscreen" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: this.state.isMobile ? "25%" : "13%", left: this.state.isMobile ? "0%" : menuToggle ? "10%" : "", overflowY: 'scroll', height: "90vh" }}>
                    <div class="modal-dialog modal-lg " role="document">
                        <div class="modal-content ">
                            <div class="modal-body pt-0 pb-2 pr-0 pl-0 ">
                                <div className="row">
                                    <div className="col-12 ">
                                        <div className='cursorPointer float-end mr-3' id="viewscreen" onClick={() => {
                                            window.$('#viewscreen').modal('hide')

                                        }} >
                                            <button className={`${classes.button} px-0 hidefield`} >&nbsp;Close</button>
                                        </div>
                                    </div>
                                    <div className='col-12 text-center'>
                                        <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel" style={{}} >
                                            <div class="carousel-indicators">

                                            </div>
                                            <div class="carousel-inner" >
                                                {this.state?.SD_Drawing && this.state?.SD_Drawing.map((i, ind) => (<>
                                                    <div class={ind === this.state.index ? "carousel-item active col-12 text-center align-middle" : " align-middle carousel-item col-12 text-center"}>
                                                        <div>
                                                            <InnerImageZoom
                                                                moveType="drag"
                                                                zoomScale={2}
                                                                hideCloseButton={true}
                                                                src={i?.Drawing?.FileUrl}
                                                                hasSpacer={true}
                                                                afterZoomIn={() => { $('#viewscreen > div > div ').addClass('Transparent'); $('.hidefield').removeClass('d-block'); $('.hidefield').addClass('d-none'); }}
                                                                afterZoomOut={() => { $('#viewscreen > div > div ').removeClass('Transparent'); $('.hidefield').addClass('d-block'); $('.hidefield').removeClass('d-none'); }}
                                                            />
                                                        </div>
                                                        {this.state.SD_Drawing.length <= 1 ? "" :
                                                            <>
                                                                <button class="carousel-control-prev my-5 hidefield" type="button" data-bs-target="#carouselExampleCaptions" onClick={() => this.preView(ind - 1)} data-bs-slide="prev">
                                                                    <span class="carousel-control-prev-icon black" aria-hidden="true"></span>
                                                                    <span class="visually-hidden">Previous</span>
                                                                </button>
                                                                <button class="carousel-control-next  my-5 hidefield" type="button" data-bs-target="#carouselExampleCaptions" onClick={() => this.nextView(ind + 1)} data-bs-slide="next">
                                                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                                    <span class="visually-hidden">Next</span>
                                                                </button></>}

                                                    </div>
                                                </>))}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        NaviLink: state.commonReducer.addNewSd,
        SD_ListView: state.SectionDivisionReducer.SD_ListView || [],
        SD_Drawing: state.SectionDivisionReducer.SD_Drawing || []
    };
}

TabSD.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TabSD))
);

